import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import AppShell from "@/components/AppShell";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <AppShell active="book">
      <div className="min-h-[60vh] flex flex-col items-center justify-center text-center" data-testid="payment-cancel-page">
        <XCircle className="w-20 h-20 text-outline" strokeWidth={1.2} />
        <h1 className="mt-6 font-headline text-3xl font-light text-primary">Payment cancelled</h1>
        <p className="mt-3 text-on-surface-variant max-w-sm">No worries — your slot wasn't charged. You can pick another time whenever you're ready.</p>
        <button onClick={() => navigate("/app/book")} className="mt-8 px-7 py-4 rounded-full zenith-cta text-white font-medium hover:opacity-90 transition-opacity duration-300" data-testid="rebook-button">
          Try booking again
        </button>
      </div>
    </AppShell>
  );
}
